import to from "await-to-js";
import { Button, Form } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { authService } from "../../modules/auth/auth.service";

import style from "./ResetPasswordPage.module.scss";

import { toastService } from "../../utils/toast.service";
import { Input } from "../../components/Input/Input";
import { ModalsContext } from "../../context/modals.context";

export const ResetPasswordPage = () => {
  const { setError } = useContext(ModalsContext);
  const [Id, setId] = useState<string>("");
  const [Password, setPassword] = useState<string>("");
  const [Token, setToken] = useState<string>("");
  const [ConfirmPassword, setConfirmPassword] = useState<string>("");

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("tokenId");
    const id = queryParams.get("id");
    if (token) {
      setToken(token);
    }
    if (id) {
      setId(id);
    }
  }, []);

  const navigate = useNavigate();

  const resetPassword = async () => {
    if (!Password || !Token || !ConfirmPassword || !Id) return;
    if (Password !== ConfirmPassword)
      return toastService.success("TOAST.PASSWORD_NOT_MATCHING");
    const [err, res] = await to(
      authService.resetPassword({ Id, Password, ConfirmPassword, Token })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.ACTIVATE_COMPANY_SUCCESS");
    if (authService.getRole().some((role) => role.includes("SKENIRANJE")))
      return navigate("/setupSuccess");
    return navigate("/loginSuccess");
  };

  const isMatching = Password === ConfirmPassword;

  return (
    <div className={style.container}>
      <div className={style.logo}>eAkcize</div>
      <div className={style.centeredDiv}>
        <h3>Unesite novu šifru za pristup portalu</h3>
        <div className={style.inputWrapper}>
          <label>Šifra</label>
          <Form.Item>
            <Input
              className={style.input}
              value={Password}
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              type="password"
            />
          </Form.Item>
          <div>Potvrdi šifru</div>
          <Form.Item
            validateStatus={!isMatching ? "error" : "success"}
            validateFirst
          >
            <Input
              className={style.input}
              value={ConfirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              name="confirm-password"
              type="password"
            />
          </Form.Item>
          <Button
            type="primary"
            onClick={resetPassword}
            className={style.confirmBtn}
          >
            Potvrdi
          </Button>
        </div>
      </div>
    </div>
  );
};
